import React from 'react';
// template components
import RelatedLinks from '@nmx/template/dist/componentLibrary/layout/Footer/RelatedLinks';

export default () => {

  const linkItems = [
    {
      linkUrl: '/investment-product-information/',
      linkId: 'related-links-investment-product-information',
      linkText: 'Investment product information',
      ariaLabel: '',
      isOutgoingLink: false,
      children: '',
    },
    {
      linkUrl: '/life-and-money/how-to-make-money-investing/',
      linkId: 'related-links-investing-disclosure',
      linkText: 'Investing disclosure',
      ariaLabel: 'See our investing disclosure',
      isOutgoingLink: false,
      children: '',
    },
    {
      linkUrl: '/mutual-funds-partners/',
      linkId: 'related-links-mutual-fund-partners',
      linkText: 'Mutual fund partners',
      ariaLabel: 'Learn more about our mutual fund partners',
      isOutgoingLink: true,
      children: '',
    },
  ];

  return (
    <RelatedLinks
      sectionId='related-links-investments-page'
      moduleName='related-links'
      moduleVariation='A'
      backgroundVariant='lightA'
      themeType='lightTheme'
      linkItems={linkItems}
      disableBottomPadding
    />
  );
};
